export const PRODUCTDIGEMID_TTL_ES = 'Productos DIGEMID';
export interface IProductDigemidBase {
  code: number;
  name: string;
  concentration: string;
  form: string;
  formSimp: string;
  presentation: string;
  laboratory: string;
  fractions: number;
  condition: string;
  conditionCode: string;
}
export interface IProductDigemid extends IProductDigemidBase {
  id: number;
  tagStatusColor: string;
}
export type IProductDigemidUpdate = Partial<IProductDigemidBase>;
